module.exports = __webpack_public_path__ + "media/images/person/med_tashiro_san-94c0c6418f665212672670b206f974d7.jpg";